import { useEffect, useState } from "react";

/**
 * Belopp-fält där användaren fritt kan skriva in ett eget belopp (från 0).
 * Clamping mot max sker medan man skriver, min-clamping först när fältet lämnas.
 */
export function AmountInput({
  value,
  onChange,
  max = 800000,
  min = 0,
  className = "",
}: {
  value: number;
  onChange: (n: number) => void;
  max?: number;
  min?: number;
  className?: string;
}) {
  const [text, setText] = useState(String(value));

  useEffect(() => {
    if (Number(text) !== value) setText(String(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <input
      type="text"
      inputMode="numeric"
      value={text}
      onFocus={(e) => e.currentTarget.select()}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^\d]/g, "");
        setText(raw);
        const n = raw === "" ? 0 : Math.min(max, Number(raw));
        if (raw !== "" && Number(raw) > max) setText(String(max));
        onChange(n);
      }}
      onBlur={() => {
        const n = Math.max(min, Math.min(max, Number(text) || 0));
        setText(String(n));
        onChange(n);
      }}
      className={className}
    />
  );
}
